<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
    <VideoPlay :videoUrl="url" ref="video" @cancelPlay="cancelPlay"></VideoPlay>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import VideoPlay from '@/components/videoplayer/videoplayer'
import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import { getBackStageVideoList, deleteVideoInfo, changeVideInfoStatus } from '@/api/MTrainVideo.js'

export default {
  mixins: [mixinsBackStack, makeFakerData],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      // otherOpt,
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          current: 1,
          pageSize: 10
        }
      },
      tableValue: [],
      url: '',  // 视频播放url
      defaultSearchParam: { searchValue: '0' },
      defaultValue: {
        searchValue: '0',
        courseLevel: '0'
      },
      utilsBtnList: [
        { name: '新增', cb: 'addVideo' },
        { name: '发布', cb: 'issue' },
        { name: '下架', cb: 'drop' },
        { name: '删除', cb: 'batchDelete' }
      ]
    }
  },
  components: {
    Table,
    Form,
    TableToolsWrap,
    AModal,
    VideoPlay
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        const params = this.handlerBeforeRequestParams()
        const { rows, total } = await getBackStageVideoList(params) // 请求表格数据接口
        const row = this.handlerDateFormat(rows) // 处理时间格式
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.tableValue.forEach((item) => {
          if (item.status === '0') {
            item.statusText = '未发布'
          } else {
            item.statusText = '已发布'
          }
          this.initSelectedRowIds() // 清空勾选的选项
        })
      } catch (error) {
        this.$apiStatusHandler(99, error.message) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      const { pagination } = this.$refs.table
      const { formModel } = this.$refs.form
      const { pageSize, pageNum } = pagination
      const params = {
        pageNum,
        pageSize,
        ...formModel
      }
      return params
    },
    addVideo() {
      this.$router.push({
        name: 'TrainingvideoOperation',
        query: { type: 'create' }
      })
    },
    // 播放视频
    toDetail(row) {
      const { fileUploadVo } = row.scope
      this.url = fileUploadVo.fileUrl
      this.$refs.video.showModal()
    },
    cancelPlay(){
      this.url = ''
    },
    // 编辑公告
    edit(row) {
      const forbidden = ['1']
      const check = forbidden.includes(row.status)
      if (check) {
        return this.$apiStatusHandler(999, '只有待发布的培训视频允许编辑')
      }
      this.$router.push({
        name: 'TrainingvideoOperation',
        query: { type: 'edit', id: row.id }
      })
    },
    issue() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['1']
      const check = selectedIds.filter((item) =>
        forbidden.includes(item.status)
      )
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的培训视频允许发布')
      }
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的培训视频!')
      }
      const ids = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定发布该内容'
      this.beforeShowModal(true, {
        source: 'changeVideInfoStatus',
        params: { ids, status: '1' }
      })
    },
    // 下架
    drop() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['0']
      const check = selectedIds.filter((item) =>
        forbidden.includes(item.status)
      )
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有已发布的培训视频允许下架')
      }
      const ids = selectedIds.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定下架已选的培训视频'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的培训视频')
      }
      this.beforeShowModal(true, {
        source: 'changeVideInfoStatus',
        params: { ids, status: '0' }
      })
    },
    // 调用发布or下架接口
    async changeVideInfoStatus(params) {
      try {
        const { msg, code } = await changeVideInfoStatus(params)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 删除的参数处理
    beforeDeleteParamsHandle(params) {
      const { id, name, fileId, status } = params
      return { id, name, fileId, status } 
    },
    // 单独删除
    singleDelete(row) {
      if (row.status === '1') {
        return this.$apiStatusHandler(999, '只有未发布的视频才允许删除')
      }
      this.customModalOpt.contentTips = '是否确定删除该视频'
      const videoDtos = this.beforeDeleteParamsHandle(row)
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: [videoDtos]
      })
    },
    // 批量删除
    batchDelete() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['1']
      const check = selectedIds.filter((item) =>
        forbidden.includes(item.status)
      )
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的培训视频允许删除')
      }
      const videoDtos = selectedIds.map((item) => {
        return this.beforeDeleteParamsHandle(item)
      })
      this.customModalOpt.contentTips = '是否确定删除已选的培训视频'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的培训视频')
      }
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: videoDtos
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      try {
        const { msg, code } = await deleteVideoInfo(params)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    }
  }
}
</script>
